export default "__VITE_ASSET__BGl1v96K__"